export type GateKind = 'add' | 'multiply';
export interface GateChoice { kind: GateKind; value: number; }
export interface GatePair { left: GateChoice; right: GateChoice; y: number; passed: boolean; }

export const applyGate = (count: number, gate: GateChoice): number =>
  Math.min(120, gate.kind === 'add' ? count + gate.value : count * gate.value);

export const gateLabel = (gate: GateChoice): string => gate.kind === 'add' ? `+${gate.value}` : `×${gate.value}`;
